module.exports = ({"version":"v3.238.4","revision":"adfcf3d088d439af7d6511aa0cccf3e66ebbe5da","applicationMode":"prod","environmentMode":"saas"})